import React from "react";
import { Modal } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./CustomModal.styles";

const CustomModal = ({ open, modalBody, onClose, ...props }) => {
  const classes = useStyles();

  const defaultSizes = {
    modalSmall: {
      modalClass: classes.modalSmall,
    },
    modalMedium: {
      modalClass: classes.modalMedium,
    },
    modalLarge: {
      modalClass: classes.modalLarge,
    },
    modalCustom: {
      modalClass: classes.modalCustom,
    },
  };

  let modalSize;
  switch (props?.modalSize) {
    case "small":
      modalSize = defaultSizes.modalSmall;
      break;
    case "medium":
      modalSize = defaultSizes.modalMedium;
      break;
    case "large":
      modalSize = defaultSizes.modalLarge;
      break;
    case "modalCustom":
      modalSize = defaultSizes.modalCustom;
      break;
    default:
      modalSize = defaultSizes.modalSmall;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={`${classes.modal} ${modalSize.modalClass}`}>
        {modalBody && modalBody}
      </div>
    </Modal>
  );
};

CustomModal.propTypes = {
  open: PropTypes.bool,
  modalBody: PropTypes.node,
  modalSize: PropTypes.string,
  onClose: PropTypes.func,
};

export { CustomModal };
